<style lang="scss" scoped>
::v-deep .el-progress-bar__outer {
  background: #606672;
}

::v-deep .el-progress__text {
  color: #ffffff;
}

::v-deep::before {
  z-index: inherit;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

::v-deep.el-table {
  background-color: transparent;
}

::v-deep.el-table--border:after,
::v-deep.el-table--group:after,
::v-deep.el-table:before {
  background-color: transparent;
}

::v-deep.el-table tr {
  background-color: transparent;
}

::v-deep .el-table__body {
  -webkit-border-vertical-spacing: 4px; // 垂直间距
}

::v-deep.el-table td.gutter,
::v-deep.el-table th.gutter {
  background: #33333a;
}

::v-deep .el-table__body-wrapper {
  background: #202027;
}

// 滚动条的宽度
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

::v-deep .el-progress__text {
  flex-shrink: 0;
}

// 滚动条的滑块
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.lists::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

.lists::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.list:nth-child(n + 2) {
  margin-top: 10px;
}

// ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
::v-deep .progress-green {
  .el-progress__text {
    color: #39f16d !important;
  }
}

::v-deep .progress-yellow {
  .el-progress__text {
    color: #ffc83a !important;
  }
}

::v-deep .progress-red {
  .el-progress__text {
    color: #ff3a5e !important;
  }
}

::v-deep .progress-gray {
  .el-progress__text {
    color: #99a0ad !important;
  }
}

::v-deep .el-progress-bar__outer {
  background: #515c69;
}

.gridMode .el-progress-bar__outer {
  background: #515c69;
}

::v-deep .el-progress {
  display: flex;
  align-items: center;
}

.scroll-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.scroll-text {
  display: inline-block;
  white-space: nowrap;
  padding-right: 40px;
}

.scroll-text.scroll-animate {
  animation: scroll-left 16s linear infinite;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" style="display: flex;justify-content: space-between;align-items: center;">
      <div style="display: flex;justify-content: space-between;align-items:center ;width: 353px;;">
        <div style="display: flex;align-items: center;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
            {{ $t('dangqianshengchan') }}
          </p>
        </div>
      </div>

      <div style="display: flex;justify-content: space-between;align-items:center ;flex: 1;margin: 0 20px;">
        <div style="display: flex;align-items: center;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
            {{ $t('daichangongdan') }}
          </p>
        </div>
      </div>
      <div style="display: flex;justify-content: space-between;align-items:center ;width: 400px;">
        <div style="display: flex;align-items: center;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
            {{ $t('lingliaoxinxi') }}
          </p>
        </div>
      </div>
    </div>
    <div class="lists" ref="lists" :style="{ height: contentHeight + 'px' }" style="overflow: auto;margin-top: 10px;">
      <div class="list" style="display: flex;justify-content: space-between;" v-for="progress in progresses">
        <div style="width: 353px;flex-shrink: 0;background: #121212;height: 344px;padding: 20px;padding-top: 16px;">
          <div style="display: flex;align-items: center;width: 100%;">
            <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 34px;font-weight: 700;width: 100px;">{{ progress.equipmentName }}</p>
            <div style="flex: 1;margin-left: 34px;" v-if="progress.progress != null">
              <el-progress :class="cardTextClass(progress.equipmentStatus)" :percentage="parseFloat(progress.progress.toFixed(1))" :color="cardTextColor(progress.equipmentStatus)"> </el-progress>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 10px;">
            <div style="width: 60%;">
              <p style="color: #C0C4CC;line-height: 22px;font-size: 14px;">{{ $t('shengchangongdanhao') }}</p>
              <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 16px;font-weight: bold;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;">
                {{ progress.wo ? progress.wo.no : '-' }}
              </p>
            </div>
            <div style="width: 40%;">
              <p style="color: #C0C4CC;line-height: 22px;font-size: 14px;">{{ $t('shebeizhuangtai') }}</p>
              <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 16px;font-weight: bold;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;">
                {{ cardStatus(progress.equipmentStatus) }}
              </p>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 10px;">
            <div style="width: 100%;">
              <p style="color: #C0C4CC;line-height: 22px;font-size: 14px;">
                {{ $t('chanpinbianma/mingcheng') }}
              </p>
              <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 16px;font-weight: bold;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;">{{ progress.material ? progress.material.code : '-' }}/{{ progress.material ? progress.material.name : '-' }}</p>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 10px;">
            <div style="width: 100%;">
              <p style="color: #C0C4CC;line-height: 22px;font-size: 14px;">{{ $t('mojubianhao/mingcheng') }}</p>
              <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 16px;font-weight: bold;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;">{{ progress.mould ? progress.mould.code : '-' }}/{{ progress.mould ? progress.mould.name : '-' }}</p>
            </div>
          </div>

          <div style="display: flex;justify-content: space-between;margin-top: 10px;">
            <div style="width: 100%;">
              <p style="color: #C0C4CC;line-height: 22px;font-size: 14px;">{{ $t('liaohao') }}</p>
              <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 16px;font-weight: bold;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;">
                {{ progress.material ? progress.material.no : '-' }}
              </p>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 10px;">
            <div style="width: 100%;">
              <p style="color: #C0C4CC;line-height: 22px;font-size: 14px;">{{ $t('wangongyuceshijian') }}</p>
              <p :style="{ color: cardTextColor(progress.equipmentStatus) }" style="font-size: 16px;font-weight: bold;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;">
                {{ progress.preFinishTime && progress.preFinishTime != null ? dayjs.unix(progress.preFinishTime / 1000).format('YYYY-MM-DD HH:mm') : '' }}
              </p>
            </div>
          </div>
        </div>
        <div style="flex: 1;margin: 0 20px;overflow: hidden">
          <el-table :tooltip-effect="'light'" ref="table1" class="productionPrepareTable" :data="progress.awaitingWoList" style="width: 100%" :max-height="344" :row-style="{ background: '#1D1D24', height: 92 + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: '#202027', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: '#33333A', color: '#C0C4CC', padding: '0px', height: '52px', borderColor: '#33333A' }">
            <el-table-column v-if="col == 'shengchangongdanhao'" prop="equipmentName" :label="$t('shengchangongdanhao')"> </el-table-column>
            <template v-for="(col, index) in monitorSetting.PREPARE_COLUMNS">
              <el-table-column v-if="col == 'shengchangongdanhao'" prop="no" :label="$t('shengchangongdanhao')"> </el-table-column>
              <el-table-column :show-overflow-tooltip="false" v-if="col == 'chanpinmingcheng'" prop="materialName" :label="$t('chanpinmingcheng')"> </el-table-column>
              <el-table-column :show-overflow-tooltip="false" v-if="col == 'liaohao'" prop="materialNo" :label="$t('liaohao')" width="200"> </el-table-column>
              <el-table-column :show-overflow-tooltip="false" v-if="col == 'mojubianhao'" prop="mouldCode" :label="$t('mojubianhao')"> </el-table-column>
              <el-table-column :show-overflow-tooltip="false" v-if="col == 'mojumingcheng'" prop="mouldName" :label="$t('mojumingcheng')"> </el-table-column>
              <el-table-column v-if="col == 'gongdanshunxu'" prop="priority" :label="$t('gongdanshunxu')"> </el-table-column>
              <el-table-column v-if="col == 'jihuakaishishijian'" prop="planStartTime" :label="$t('jihuakaishishijian')">
                <template slot-scope="scope">
                  {{ scope.row.planStartTime != null ? dayjs.unix(scope.row.planStartTime / 1000).format('YYYY-MM-DD HH:mm') : '' }}
                </template>
              </el-table-column>
              <el-table-column v-if="col == 'huanmozhuangtai'" prop="dieChangeStatus" :label="$t('huanmozhuangtai')">
                <template slot-scope="scope">
                  <div style="line-height: 28px;">
                    <span v-if="scope.row.dieChangeStatus == 0" style="color:#FF3A5E;border: 1px solid #FF3A5E;background: rgba(255, 58, 94, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('weichuli') }}</span>
                    <span v-if="scope.row.dieChangeStatus == 1" style="color:#39F16D;border: 1px solid #39F16D;background: rgba(57, 241, 109, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('yiwancheng') }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="col == 'beiliaozhuangtai'" prop="stockStatus" :label="$t('beiliaozhuangtai')">
                <template slot-scope="scope">
                  <div style="line-height: 28px;">
                    <span v-if="scope.row.stockStatus == 0" style="color:#FF3A5E;border: 1px solid #FF3A5E;background: rgba(255, 58, 94, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('weichuli') }}</span>
                    <span v-if="scope.row.stockStatus == 1" style="color:#39F16D;border: 1px solid #39F16D;background: rgba(57, 241, 109, 0.2);border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;">{{ $t('yiwancheng') }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div style="width: 400px;flex-shrink: 0;">
          <el-table ref="table2" class="productionPrepareTable" :data="progress.woStockList" style="width: 100%" :max-height="344" :row-style="{ background: '#1D1D24', height: 92 + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: '#1D1D24', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: '#33333A', color: '#C0C4CC', padding: '0px', height: '52px', borderColor: '#202027' }">
            
            <el-table-column label="原材料名称">
              <template slot-scope="scope">
                <div class="scroll-container" v-if="scope.row.materialName">
                  <span class="scroll-text" :class="{ 'scroll-animate': scope.row.materialName.length > 10 }">{{ scope.row.materialName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ scope.row.materialName }}</span>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_prepare_meilida_row',
  components: {},
  data() {
    return {
      monitorSetting: {},
      interval: null,
      timmer: null,
      contentHeight: 0,
      tableWidth: 0,
      progresses: [],
      isStopListScroll: false,
      isStopScroll: false
    };
  },
  created() {
    this.timmer = setInterval(() => {
      this.listProductionProgress();
    }, 120000);
    this.setPrepare();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('SetPrepare', () => {
      this.setPrepare();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    clearInterval(this.timmer);
  },

  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listProductionProgress();
    }
  },
  computed: {
    cardStatus() {
      return index => {
        return {
          '0': this.$t('yunxingzhong'),
          '3': this.$t('guzhang'),
          '1': this.$t('kongxian'),
          '-1': this.$t('lixian')
        }[index];
      };
    },
    cardTextColor() {
      return index => {
        return {
          '0': '#39F16D',
          '3': '#FF3A5E',
          '1': '#FFC83A',
          '-1': '#99A0AD'
        }[index];
      };
    },
    cardTextClass() {
      return index => {
        return {
          '0': 'progress-green',
          '3': 'progress-red',
          '1': 'progress-yellow',
          '-1': 'progress-gray'
        }[index];
      };
    }
  },
  methods: {
    setPrepare() {
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
      this.listProductionProgress();
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        // 1. 滚动外层列表容器
        let lists = this.$refs.lists;
        if (lists) {
          this.scrollDiv(lists);
        }
        // 2. 滚动第一个表格 (table1)
        let table1 = this.$refs.table1;
        if (table1) {
          // 确保是数组，如果不是数组则转为数组处理
          const table1s = Array.isArray(table1) ? table1 : [table1];
          table1s.forEach(tableComponent => {
            // 获取 el-table 内部的滚动容器 DOM
            // el-table 的滚动体通常是 .el-table__body-wrapper
            if (tableComponent && tableComponent.$el) {
              const scrollWrapper = tableComponent.$el.querySelector('.el-table__body-wrapper');
              if (scrollWrapper) {
                this.scrollDiv(scrollWrapper);
              }
            }
          });
        }
        // 3. 滚动第二个表格 (table2)
        let table2 = this.$refs.table2;
        if (table2) {
          const table2s = Array.isArray(table2) ? table2 : [table2];
          table2s.forEach(tableComponent => {
            if (tableComponent && tableComponent.$el) {
              const scrollWrapper = tableComponent.$el.querySelector('.el-table__body-wrapper');
              if (scrollWrapper) {
                this.scrollDiv(scrollWrapper);
              }
            }
          });
        }
      }, 100);
    },
    scrollDiv(listDiv) {
      // 增加安全检查，确保 listDiv 是有效的 DOM 元素
      if (!listDiv || !listDiv.scrollTop === undefined) {
        return;
      }
      if (!this.isStopScroll) {
        // 防止 scrollTop 为 NaN 或无限增长
        listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
        // 使用 Math.ceil 或稍微宽松的比较，避免浮点数精度问题导致无法重置
        if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight - 1) {
          this.isStopScroll = true;
          setTimeout(() => {
            // 再次检查，确保还在底部
            if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight - 1) {
              listDiv.scrollTop = 0;
            }
            this.isStopScroll = false;
          }, 5000);
        }
      }
    },

    async listProductionProgress() {
      let response = await this.http.get('/web/production/wo/monitor/predelivery/span_mld', {
        params: {
          orgId: this.$attrs.orgId,
          span: (this.monitorSetting.PREPARE_PLAN_HOUR ? this.monitorSetting.PREPARE_PLAN_HOUR : 12) * 60 * 60
        }
      });

      this.progresses = response.data;
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.$refs.titleBar == null) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20 - 10;
      }, 800);
    }
  }
};
</script>
